export const TEXTAREA_DEFAULT_FONT_SIZE: number = 14;

export const TEXTAREA_MIN_FONT_SIZE: number = 10;

export const TEXTAREA_DEFAULT_HEIGHT: number =
  TEXTAREA_DEFAULT_FONT_SIZE * 1.22;
